// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"C0-z"};